module.exports = __webpack_public_path__ + "img/csal.3950e9d3.png";